import { render, staticRenderFns } from "./GoodInfoDialog.vue?vue&type=template&id=1cf3b4e1&scoped=true&"
import script from "./GoodInfoDialog.vue?vue&type=script&lang=js&"
export * from "./GoodInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodInfoDialog.vue?vue&type=style&index=0&id=1cf3b4e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3b4e1",
  null
  
)

export default component.exports